<template>
  <div class="container">
    <div class="header">
      <span style="cursor: pointer" @click="$router.push('/')"><i class="el-icon-arrow-left"></i>返回首页</span>
      <h3 style="font-size: 28px">中财国培教育服务条款</h3>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 0 auto;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
